import { Button, Grid, TextField } from '@material-ui/core'
import { isEqual } from 'lodash'
import React, { memo } from 'react'
import { useForm } from 'react-hook-form'
import { metodoPrograma } from '../../components/api'

const retornaUsuario = (u = []) => ({
  idUsuario: u[0] || undefined,
  dsEmail: u[2] || '',
  dsNome: u[3] || '',
  dtExclusao: u[5] || '',
  dtInclusao: u[4] || '',
  dsSenha: '',
  dsSenhaConfirmacao: '',
})

const Edicao = ({ contratante, idTipoUsuario, usuarioAberto, voltar }) => {
  const { register, handleSubmit } = useForm({
    defaultValues: retornaUsuario(usuarioAberto),
  })

  const salva = async (values) => {
    if (values.dsSenha !== values.dsSenhaConfirmacao) {
      alert('As senhas não conferem')
      return
    }
    const dados = {
      ...values,
      idContratante: contratante[0],
      idTipoUsuario,
    }
    const res = await metodoPrograma('salva', dados)
    if (res.status) voltar()
    else alert(res.dsErro)
  }
  return (
    <form onSubmit={handleSubmit(salva)}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <TextField
            {...register('dsNome')}
            name="dsNome"
            label="Name"
            fullWidth
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <TextField
            {...register('dsEmail')}
            name="dsEmail"
            label="Email"
            fullWidth
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
          <TextField
            {...register('dtInclusao')}
            name="dtInclusao"
            label="Inclusion"
            disabled
            fullWidth
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
          <TextField
            {...register('dtExclusao')}
            name="dtExclusao"
            label="Deletion"
            disabled
            fullWidth
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
          <TextField
            {...register('dsSenha')}
            type="password"
            name="dsSenha"
            label="Password"
            fullWidth
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
          <TextField
            {...register('dsSenhaConfirmacao')}
            type="password"
            name="dsSenhaConfirmacao"
            label="Password Confirmation"
            fullWidth
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: 'flex', flexDirection: 'row-reverse' }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ margin: '5px' }}
          >
            Save
          </Button>
          <Button
            onClick={voltar}
            variant="contained"
            color="secondary"
            style={{ margin: '5px' }}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default memo(Edicao, isEqual)
